module.exports = __webpack_public_path__ + "static/media/avatar_tim_lawrence.f0b2e077.jpg";